module.exports = __webpack_public_path__ + "fenyx.png";